import { helper } from '@ember/component/helper';
import { courseCashMark } from '../utils/course-cash-mark.ts';
import type { SafeString } from '@ember/template';

/**
 * Styles the CourseCa$h™ brand token(s) inside an arbitrary string, returning an
 * htmlSafe SafeString. The input is HTML-escaped first, so it is safe to pass real
 * program names or translated copy.
 *
 * {{course-cash-mark (t "some.key")}}
 * {{course-cash-mark program.name}}
 */
export default helper(function ([value]: [string | null | undefined]): SafeString {
  return courseCashMark(value ?? '');
});
